import { render } from "./LRegisterForm.vue?vue&type=template&id=86ec9662&scoped=true&ts=true"
import script from "./LRegisterForm.vue?vue&type=script&lang=ts"
export * from "./LRegisterForm.vue?vue&type=script&lang=ts"

import "./LRegisterForm.vue?vue&type=style&index=0&id=86ec9662&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86ec9662"]])

export default __exports__